import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import styles from "./BattleRoundLog.module.scss"
import { IBattleRoundLogProps } from "./types"

const BattleRoundLogComponent: FC<IBattleRoundLogProps> = ({ lines }) => {
  const { t } = useTranslation(["battle", "inventory"])

  if (lines.length === 0) {
    return <p className={styles.BattleRoundLog_empty}>{t("screen.noLog")}</p>
  }

  return (
    <ul className={styles.BattleRoundLog}>
      {lines.map((line, index) => (
        <li key={`${line.key}:${index}`} className={styles.BattleRoundLog_line}>
          {t(line.key, {
            ...line.params,
            ability: line.abilityId
              ? t(`ability.${line.abilityId}`, {
                  defaultValue: line.abilityId
                })
              : undefined,
            potion: line.itemCode
              ? t(`inventory:item.${line.itemCode}.name`, {
                  defaultValue: line.itemCode
                })
              : undefined
          })}
        </li>
      ))}
    </ul>
  )
}

export const BattleRoundLog = memo(BattleRoundLogComponent)
